<template>
  <el-dialog :title="activeItem.id
?'编辑信息':'添加信息'"
    :visible.sync="$parent.dialogVisible"
    width="30%">
    <el-form label-position="right"
      label-width="80px"
      :model="form"
      :rules="rules"
      ref="ruleForm">
      <el-form-item label="资讯标题"
        prop="title">
        <el-input v-model="form.title"
          maxlength="40"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="资讯摘要"
        prop="content">
        <el-input type="textarea"
          v-model="form.content"
          resize="none"
          rows="7"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="资讯配图"
        prop="imageUrl">
        <el-upload :class="{hide:hideUpload,show:showUpload}"
          action="#"
          ref="uploadImport"
          list-type="picture-card"
          :auto-upload="false"
          :on-change="onChange"
          :on-remove="handleRemove"
          :on-success="onSuccess"
          :http-request="fileLists"
          :file-list="fileListData"
          accept=".png,.jpg,jpeg"
          :limit="1">
          <i slot="default"
            class="el-icon-plus"></i>
        </el-upload>
        <el-button style="margin-left: 10px;"
          size="small"
          @click="submitUpload">上传</el-button>
      </el-form-item>
    </el-form>
    <span slot="footer"
      class="dialog-footer">
      <el-button @click="$parent.dialogVisible = false">取 消</el-button>
      <el-button type="primary"
        @click="submit('ruleForm')"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import { dateFtt } from "@/assets/js/utils";
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        title: "",
        content: "",
        imageUrl: "",
      },
      rules: {
        title: [
          { required: true, message: "标题不能为空" },
          { whitespace: true, message: "标题不能为空" },
          { min: 1, max: 40, message: "请输入不超过 40 个字", trigger: "blur" },
        ],
        content: [
          { required: true, message: "资讯摘要不能为空" },
          { whitespace: true, message: "资讯摘要不能为空" },
        ],
        imageUrl: [
          {
            required: true,
            message: "请选择图片并点击上传",
            trigger: "blur",
          },
        ],
      },
      loading: false,
      fileImgUrl: "", // 图片地址
      hideUpload: false,
      showUpload: false,
      fileListData: [],
    };
  },
  methods: {
    submitUpload() {
      if (this.fileListData.length) {
        this.$message.warning("已上传,如需更改请重新选择图片!");
        return;
      }
      if (!this.fileImgUrl) {
        this.$message.error("请选择图片");
        return;
      }
      this.$refs.uploadImport.submit();
    },
    // 文件状态改变时，添加文件、上传成功和上传失败时都会被调用
    onChange(file, fileList) {
      this.hideUpload = fileList.length >= 1;
      this.fileImgUrl = fileList[0].url;
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      // 当删除照片时，显示上传组件
      this.hideUpload = false;
      this.showUpload = fileList.length < 1;
      this.fileImgUrl = "";
      this.fileListData = [];
      this.form.imageUrl = "";
    },
    fileLists(param) {
      let userToken = window.sessionStorage.getItem("token");
      let httpUrl = window.jujiParams.baseURL;
      let fd = new FormData();
      fd.append("file", param.file);
      axios
        .post(httpUrl + "/api/juji/filesvc/upload", fd, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Authorization": `Bearer ${userToken}`,
          },
        })
        .then((res) => {
          if (res && res.status == 200) {
            param.onSuccess(res);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {});
    },
    onSuccess(response, file, fileList) {
      this.form.imageUrl = response.data.uri;
    },

    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let obj = {
            id: this.activeItem.id ?? null,
            time: dateFtt("yyyy-MM-dd hh:mm:ss", new Date()),
            title: this.form.title,
            content: this.form.content,
            uri: this.form.imageUrl,
          };
          this.$emit("handleSubmit", obj);
        } else {
          return false;
        }
      });
    },
  },
  created() {
    if (this.activeItem.id) {
      this.form.imageUrl = this.activeItem.image;
      this.fileListData = [{ url: this.activeItem.imgUrl }];
      this.form.title = this.activeItem.title;
      this.form.content = this.activeItem.content;
      this.hideUpload = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
::v-deep .hide .el-upload--picture-card {
  display: none;
}
:v-deep .show .el-upload--picture-card {
  display: block;
}
</style>